<template>
  <div class="editor-setting">
    <div class="editor-setting-header">
      <span>{{ $t("message.workBench.body.script.setting.header") }}</span>
      <Icon type="ios-close" @click="$emit('setting-close')" />
    </div>
    <div class="editor-setting-content">
      <!-- <div class="wrapper">
        <!-- 	<BloodConfig
			ref="blood-config"
			:blood="blood"
		></BloodConfig>
      </div>
      <div class="wrapper">
        <WarningMember :warning-member-list="warningMemberList"></WarningMember>
      </div>
      <div class="wrapper">
        
      </div> -->
     <div class='wrapper'>
        <h4 class="dependency">依赖关系配置</h4>
      <slot></slot>
      </div>
      <custom-variable ref="customVariable" :script="script"></custom-variable>
      <!-- <runtime-args
        v-if="work.type==='node'"
        ref="runtimeArgs"
        :script="script"></runtime-args>
      <env-variable
        v-if="work.type==='node'"
        ref="envVariable"
        :script="script"></env-variable> -->
    </div>
  </div>
</template>
<script>
import customVariable from "../setting/customVariable.vue";
// import runtimeArgs from '../setting/runTimeArgs.vue';
// import envVariable from '../setting/envVariable.vue';

import BloodConfig from "@/component/data-development/blood-config.vue";

import WarningMember from "@/component/data-development/warning-member.vue";

import { isEqual } from "lodash";

export default {
  name: "Setting",
  components: {
    customVariable,
    // runtimeArgs,
    // envVariable,

    // 增加血缘配置
    BloodConfig,
    // 增加作业预警成员
    WarningMember,
  },
  props: {
    work: {
      type: Object,
      required: true,
    },
    script: {
      type: Object,
      required: true,
    },
    blood: {
      type: Object,
      required: true,
    },
    warningMemberList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      origin: null,
    };
  },
  watch: {
    "script.params": {
      handler: function (val) {
        this.work.unsave = !isEqual(JSON.parse(this.origin), val);
      },
      deep: true,
    },
  },
  mounted() {
    this.origin = JSON.stringify(this.script.params);
  },
};
</script>
<style scoped>
.dependency{
  padding:10px;
  background-color: hsla(0,0%,100%,.7);;
}
</style>